<template>
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class="searchBox inpBox1">
            <div class="item">
              <el-form-item label="抢单单号:" prop="demandNo">
                <el-input placeholder="" v-model="searchFrom.demandNo"></el-input>
              </el-form-item>
              <el-form-item label="抢单状态:" prop="status">
                <el-select v-model="searchFrom.status" placeholder="请选择">
                  <el-option v-for="val in options" :label="val.name" :value="val.id" :key="val.id"></el-option>
                </el-select>
              </el-form-item>
            </div>
        </div>
        <div class="searchBtnBox">
              <el-form-item>
                  <el-button type="primary" @click="searchFn" v-if="btnFlg[0]">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
                </el-form-item>
            </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border :row-class-name="tableRowClassName">
          <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <div>
                <el-button type="text" size="mini" v-if="btnFlg[1]" @click="yichangFn(scope.row)">{{scope.row.isException==1?'解除异常':'异常'}}</el-button>
                <el-button type="text" size="mini" @click="resultFn(scope.row)"  v-if="scope.row.status == '1203'">结果</el-button>
            </div>
          </template>
        </el-table-column>
      <el-table-column label="抢单单号" width="240">
          <template slot-scope="scope">
            <span style="color: #0c46a2;cursor: pointer;" @click="detailFn(scope.row)">{{scope.row.demandNo}}</span>
          </template>
        </el-table-column>
         <el-table-column prop="demandFinalDate"  min-width="160" :formatter="(row, column,cellValue,index) => dateTimeFormat(row, column,cellValue,index, 1)" label="抢单截至时间"></el-table-column>
        <el-table-column  prop="status"  min-width="120" :formatter="statusFormat" label="抢单状态"></el-table-column>
        <el-table-column prop="productTypeName"  min-width="170" :formatter="emptyFn" label="货物类型"></el-table-column>
      <el-table-column label="委托量" width="160">
          <template slot-scope="scope">
            <div>
              {{scope.row.productWeight}}吨/{{scope.row.productNum}}件
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="unitPrice"  min-width="170"  label="指派价">
           <template slot-scope="scope">
            <div>
              {{scope.row.unitPrice}}{{scope.row.pricingMethod==1?'元/吨':'元'}}
            </div>
          </template>
        </el-table-column>
         <el-table-column  prop="tenantName"  min-width="260"  label="委托方"></el-table-column>
         <el-table-column prop="carriageName"  min-width="170" :formatter="emptyFn" label="承运方"></el-table-column>
         <el-table-column label="发货信息" width="450">
          <template slot-scope="scope">
            <div class="box1">
              <span style="color:#0c46a2">(发){{scope.row.deliverCompany}}</span>
              <span>{{scope.row.deliverPerson}}</span>
            </div>
            <div class="box1">
              <span>{{scope.row.deliverPhone}}</span>
              <span>{{scope.row.deliverAddress}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="收货信息" width="450">
          <template slot-scope="scope">
            <div class="box1">
              <span style="color:#F56C6C">(收){{scope.row.receivingCompany}}</span>
              <span>{{scope.row.receivingPerson}}</span>
            </div>
            <div class="box1">
              <span>{{scope.row.receivingPhone}}</span>
              <span>{{scope.row.receivingAddress}}</span>
            </div>
          </template>
        </el-table-column>
       <el-table-column prop="hopeReceivingDate"  min-width="160" :formatter="(row, column,cellValue,index) => dateTimeFormat(row, column,cellValue,index, 1)" label="最晚提货时间"></el-table-column>
        <el-table-column prop="publishUserName"  min-width="130" :formatter="emptyFn" label="创建人" show-overflow-tooltip></el-table-column>
        <el-table-column prop="publishTime"  min-width="160" :formatter="dateTimeFormat" label="创建时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>

      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog  title="查看结果"  :close-on-click-modal="false" :close-on-press-escape="false"  :visible.sync="isEdit" @close="closeDialog" width="1100px" center>
        <div>
           <div class="spry">
              <div style="margin: 20px 0;justify-content: space-between;display: flex;">
                <span> 成交承运商：{{sDemandOfferList[0].carriageName}}</span>
                 <span> 成交时间：{{dateFormatUtil('yyyy-MM-dd hh:ii',sDemandOfferList[0].completeTime)}}</span>
              </div>
              <div class="tbox">
                <el-table :data="sDemandOfferList" border ref="CDtable" highlight-current-row  max-height="350px" >
                  <el-table-column type="index" prop="date" width="55" :reserve-selection="true" label="序号"></el-table-column>
                  <el-table-column property="pricingMethod" label="报价方式"  min-width="150px">
                    <template scope="scope">{{[ "单价", "包干" ][scope.row.pricingMethod-1]}}</template>
                  </el-table-column>
                  <el-table-column prop="offerPrice" min-width="160px" :formatter="emptyFn" label="成交报价(元)" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="dealPrice"  min-width="120px" :formatter="emptyFn" label="运费(元)"></el-table-column>
                  <el-table-column prop="serviceFee"  min-width="140px" :formatter="emptyFn" label="找车服务费(含税/元)"></el-table-column>
                   <el-table-column prop="incidental"  min-width="130px" :formatter="emptyFn" label="杂费(元)"></el-table-column>
                  <el-table-column  min-width="130px" :formatter="emptyFn" label="合计(元)">
                    <template scope="scope">
                      <div>
                        {{Number(toFixed(parseFloat(scope.row.dealPrice) + parseFloat(scope.row.serviceFee) + (scope.row.incidental ? parseFloat(scope.row.incidental) : 0), 2))}}
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isEdit = false" type='primary'>关闭</el-button>
        </span>
    </el-dialog>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat, dateFormatUtil, toFixed } from '@/utils/util'
import {
  monitorSeckillSDemandList,
  showBiddingResult,
  isExceptionOrTrigger // 异常
} from '@/api/soc-customer'
export default {
  data () {
    return {
      options: [
        { name: '待抢单', id: 1002 },
        { name: '抢单成功', id: 1203 },
        { name: '抢单失败', id: 1202 },
        { name: '已作废', id: 1201 }
      ],
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      dateFormatUtil: dateFormatUtil,
      toFixed: toFixed,
      dialogVisible: false,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      loading: false,
      isEdit: false, // 结果
      sDemandOfferList: [{ carriageName: '' }],
      btnFlg: [],
      btnIdArr: ['009M0G0100', '009M0G0200']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/CgrabOrdersMonitor')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {
    resultFn (row) {
      showBiddingResult({ demandId: row.id, offerFlag: 0 }).then(res => {
        this.isEdit = true
        this.sDemandOfferList = [res]
      }).catch(error => {
        this.$message({
          message: error.message,
          type: 'error'
        })
      })
    },
    detailFn (row) {
      this.$router.push({ name: 'details', query: { id: row.id } })
    },
    // 异常/解除异常
    yichangFn (row) {
      let str = ''
      if (row.isException == 1) {
        str = '解除异常'
      } else {
        str = '异常'
      }
      this.$confirm('是否执行' + str + '操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        isExceptionOrTrigger({ id: row.id, isException: row.isException == 1 ? 2 : 1 }).then(res => {
          loading.close()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList () {
      this.loading = true
      monitorSeckillSDemandList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null
      }
    },
    closeDialog () {

    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.isException == 1) {
        return 'warning-row'
      } else {
        return ''
      }
    },
    // 状态格式化
    statusFormat (row, column, cellValue) {
      switch (cellValue) {
        case 1002:
          return '待抢单'
        case 1102:
          return '待比价'
        case 1203:
          return '抢单成功'
        case 1202:
          return '抢单失败'
        case 1201:
          return '已作废'
      }
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox1 .el-date-editor{
  width: 350px!important;
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
.jiage .el-form-item__content {
  position: relative;
  .identiCode1 {
    position: absolute;
    right: 14px;
    color: #409eff;
  }
  .danwei1 {
    position: absolute;
    right: 14px;
    color: white;
    padding: 7px 4px;
  }
}
/deep/.inpBox1 .el-input__inner {
    width: 180px;
}
/deep/.el-table .warning-row {
    background: #FBD4D3!important;
  }
</style>
